var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0H2.15625C2.84375 0 3.46875 0.40625 3.75 1H16.5938C17.4062 1 18 1.78125 17.7812 2.59375L16.5 7.34375C16.25 8.34375 15.3438 9 14.3438 9H5.3125L5.5 9.90625C5.5625 10.25 5.875 10.5 6.21875 10.5H15.25C15.6562 10.5 16 10.8438 16 11.25C16 11.6875 15.6562 12 15.25 12H6.21875C5.15625 12 4.21875 11.25 4.03125 10.1875L2.40625 1.71875C2.375 1.59375 2.28125 1.5 2.15625 1.5H0.75C0.3125 1.5 0 1.1875 0 0.75C0 0.34375 0.3125 0 0.75 0ZM4.09375 2.5L5.03125 7.5H14.3438C14.6875 7.5 14.9688 7.28125 15.0625 6.96875L16.25 2.5H4.09375ZM5.5 16C4.9375 16 4.46875 15.7188 4.1875 15.25C3.90625 14.8125 3.90625 14.2188 4.1875 13.75C4.46875 13.3125 4.9375 13 5.5 13C6.03125 13 6.5 13.3125 6.78125 13.75C7.0625 14.2188 7.0625 14.8125 6.78125 15.25C6.5 15.7188 6.03125 16 5.5 16ZM16 14.5C16 15.0625 15.6875 15.5312 15.25 15.8125C14.7812 16.0938 14.1875 16.0938 13.75 15.8125C13.2812 15.5312 13 15.0625 13 14.5C13 13.9688 13.2812 13.5 13.75 13.2188C14.1875 12.9375 14.7812 12.9375 15.25 13.2188C15.6875 13.5 16 13.9688 16 14.5Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.4099291960ea3c697d264a8bc4a9030d.svg";
export { ForwardRef as ReactComponent };